import usersComponent from './users.component';
import UsersCreate from './create'
import UsersEdit from './edit'
import UsersAll from './all'

let usersModule = angular.module('users', [
    UsersCreate,
    UsersEdit,
    UsersAll
  ])

  .component('users', usersComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('users.edit', {
        url: '/edit/:id',
        component: 'usersedit',
        // data: {
        //   requireACL: 'setting-users.edit'
        // }
      })

      .state('users.create', {
        url: '/create',
        component: 'userscreate',
        data: {
          requireACL: 'setting-users.create'
        }
      })

      .state('users.all', {
        url: '/all/:page',
        component: 'usersall',
        data: {
          requireACL: 'setting-users.view'
        }        
      })
  })

  .name;

export default usersModule;


// WEBPACK FOOTER //
// ./client/app/components/users/index.js